import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, ChevronLeft, ChevronRight, SlidersHorizontal, X } from 'lucide-react';
import Header from './components/Header13';
import Footer from './components/Footer13';

const Shop13 = () => {
    const navigate = useNavigate();
    const [activeFilter, setActiveFilter] = useState('All');
    const [sortBy, setSortBy] = useState('featured');
    const [currentPage, setCurrentPage] = useState(1);
    const [wishlist, setWishlist] = useState({});
    const [hoveredCard, setHoveredCard] = useState(null);
    const [showFilters, setShowFilters] = useState(false);

    const categories = ['All', 'Handloom', 'Block Print', 'Ikat', 'Kalamkari', 'Silk'];

    const sortOptions = [
        { value: 'featured', label: 'Featured' },
        { value: 'price-low', label: 'Price: Low to High' },
        { value: 'price-high', label: 'Price: High to Low' },
        { value: 'newest', label: 'Newest First' },
    ];

    const products = [
        { id: 1, name: 'Chanderi Silk Handloom Saree', category: 'Handloom', price: 4999, badge: 'Bestseller', image: 'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 2, name: 'Jaipur Block Print Kurta', category: 'Block Print', price: 2499, badge: 'New', image: 'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 3, name: 'Pochampally Ikat Dupatta', category: 'Ikat', price: 1899, image: 'https://images.pexels.com/photos/3014853/pexels-photo-3014853.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 4, name: 'Kalamkari Hand-painted Saree', category: 'Kalamkari', price: 6999, badge: 'Artisan Pick', image: 'https://images.pexels.com/photos/4614070/pexels-photo-4614070.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 5, name: 'Banarasi Brocade Silk Saree', category: 'Silk', price: 9999, image: 'https://images.pexels.com/photos/6712360/pexels-photo-6712360.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 6, name: 'Ajrakh Block Print Stole', category: 'Block Print', price: 1299, badge: 'New', image: 'https://images.pexels.com/photos/7275385/pexels-photo-7275385.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 7, name: 'Patola Double Ikat Saree', category: 'Ikat', price: 8499, image: 'https://images.pexels.com/photos/8953474/pexels-photo-8953474.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 8, name: 'Maheshwari Handloom Dupatta', category: 'Handloom', price: 999, image: 'https://images.pexels.com/photos/2955375/pexels-photo-2955375.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 9, name: 'Tussar Silk Saree', category: 'Silk', price: 5499, image: 'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 10, name: 'Bagru Block Print Kurta', category: 'Block Print', price: 1999, image: 'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 11, name: 'Sambalpuri Ikat Saree', category: 'Ikat', price: 3999, image: 'https://images.pexels.com/photos/3014853/pexels-photo-3014853.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 12, name: 'Kalamkari Cotton Dupatta', category: 'Kalamkari', price: 799, image: 'https://images.pexels.com/photos/4614070/pexels-photo-4614070.jpeg?auto=compress&cs=tinysrgb&w=400' },
    ];

    const filteredProducts = activeFilter === 'All' ? products : products.filter(p => p.category === activeFilter);
    const sortedProducts = [...filteredProducts].sort((a, b) => {
        if (sortBy === 'price-low') return a.price - b.price;
        if (sortBy === 'price-high') return b.price - a.price;
        return 0;
    });

    const toggleWishlist = (e, productId) => {
        e.stopPropagation();
        setWishlist(prev => ({ ...prev, [productId]: !prev[productId] }));
    };

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@400;700&family=Mulish:wght@300;400;600&display=swap');
            `}</style>

            <div style={{ fontFamily: "'Mulish', sans-serif" }} className="min-h-screen bg-[#FBF8F4]">
                <Header />

                {/* Hero Banner */}
                <div style={{ paddingTop: '72px' }}>
                    <div style={{ backgroundColor: '#F7F3ED', padding: '48px 20px 48px', textAlign: 'center', borderBottom: '1px solid #E7E0D6' }}
                        className="md:py-20">
                        <p style={{ fontFamily: "'Mulish', sans-serif", fontSize: '12px', letterSpacing: '4px', color: '#C2410C', textTransform: 'uppercase', fontWeight: 600, marginBottom: '12px' }}>
                            Artisan Collection
                        </p>
                        <h1 style={{ fontFamily: "'Merriweather', Georgia, serif", fontSize: '32px', fontWeight: 700, color: '#1C1917', marginBottom: '12px' }}
                            className="md:text-5xl">
                            Our Crafts
                        </h1>
                        <p style={{ fontFamily: "'Mulish', sans-serif", fontSize: '15px', color: '#78716C', maxWidth: '500px', margin: '0 auto' }}>
                            Discover handcrafted pieces that celebrate India's timeless craft traditions
                        </p>
                    </div>
                </div>

                {/* Filters */}
                <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '24px 20px' }}>
                    {/* Mobile Filter Toggle */}
                    <div className="lg:hidden" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                        <p style={{ fontSize: '14px', color: '#78716C' }}>{sortedProducts.length} products</p>
                        <button onClick={() => setShowFilters(!showFilters)}
                            style={{ display: 'flex', alignItems: 'center', gap: '6px', background: 'none', border: '1px solid #E7E0D6', borderRadius: '4px', padding: '8px 14px', cursor: 'pointer', fontSize: '13px', color: '#1C1917' }}>
                            <SlidersHorizontal size={14} /> Filter
                        </button>
                    </div>

                    {/* Category Pills */}
                    <div className="flex overflow-x-auto gap-2 pb-3 lg:justify-center lg:flex-wrap" style={{ scrollbarWidth: 'none' }}>
                        {categories.map((cat) => (
                            <button key={cat} onClick={() => setActiveFilter(cat)}
                                style={{
                                    padding: '8px 20px', borderRadius: '20px', border: 'none', cursor: 'pointer', whiteSpace: 'nowrap',
                                    fontFamily: "'Mulish', sans-serif", fontSize: '13px', fontWeight: 600, letterSpacing: '0.5px',
                                    backgroundColor: activeFilter === cat ? '#C2410C' : '#F7F3ED',
                                    color: activeFilter === cat ? '#FFFFFF' : '#1C1917',
                                    transition: 'all 0.3s',
                                }}>
                                {cat}
                            </button>
                        ))}
                    </div>

                    {/* Sort (Desktop) */}
                    <div className="hidden lg:flex" style={{ justifyContent: 'space-between', alignItems: 'center', padding: '16px 0' }}>
                        <p style={{ fontSize: '14px', color: '#78716C' }}>{sortedProducts.length} products</p>
                        <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}
                            style={{ padding: '8px 16px', border: '1px solid #E7E0D6', borderRadius: '4px', backgroundColor: '#FBF8F4', fontFamily: "'Mulish', sans-serif", fontSize: '13px', color: '#1C1917', outline: 'none', cursor: 'pointer' }}>
                            {sortOptions.map(opt => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Products Grid */}
                <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 20px 80px' }}>
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-6">
                        {sortedProducts.map((product) => (
                            <div key={product.id}
                                onClick={() => navigate(`/template13/product/${product.id}`)}
                                onMouseEnter={() => setHoveredCard(product.id)}
                                onMouseLeave={() => setHoveredCard(null)}
                                style={{
                                    backgroundColor: '#FBF8F4', borderRadius: '8px',
                                    border: `1px solid ${hoveredCard === product.id ? '#C2410C' : '#E7E0D6'}`,
                                    cursor: 'pointer', overflow: 'hidden', transition: 'all 0.3s',
                                    transform: hoveredCard === product.id ? 'translateY(-4px)' : 'none',
                                    boxShadow: hoveredCard === product.id ? '0 8px 24px rgba(194, 65, 12, 0.12)' : 'none',
                                }}>
                                <div style={{ position: 'relative', aspectRatio: '3/4', overflow: 'hidden' }}>
                                    <img src={product.image} alt={product.name}
                                        style={{ width: '100%', height: '100%', objectFit: 'cover', transform: hoveredCard === product.id ? 'scale(1.05)' : 'scale(1)', transition: 'transform 0.5s' }} />
                                    {product.badge && (
                                        <span style={{ position: 'absolute', top: '10px', left: '10px', backgroundColor: '#C2410C', color: '#FFF', fontSize: '10px', fontWeight: 600, padding: '3px 8px', borderRadius: '4px', letterSpacing: '0.5px', textTransform: 'uppercase' }}>{product.badge}</span>
                                    )}
                                    <button onClick={(e) => toggleWishlist(e, product.id)}
                                        style={{ position: 'absolute', top: '10px', right: '10px', width: '34px', height: '34px', borderRadius: '50%', backgroundColor: 'rgba(251, 248, 244, 0.9)', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <Heart size={15} style={{ color: wishlist[product.id] ? '#C2410C' : '#78716C', fill: wishlist[product.id] ? '#C2410C' : 'none' }} />
                                    </button>
                                </div>
                                <div style={{ padding: '14px' }}>
                                    <p style={{ fontSize: '10px', color: '#C2410C', letterSpacing: '1.5px', textTransform: 'uppercase', fontWeight: 600, marginBottom: '4px' }}>{product.category}</p>
                                    <h3 style={{ fontFamily: "'Merriweather', Georgia, serif", fontSize: '14px', fontWeight: 400, color: '#1C1917', marginBottom: '6px', lineHeight: 1.3 }}>{product.name}</h3>
                                    <span style={{ fontSize: '15px', fontWeight: 600, color: '#1C1917' }}>{`\u20B9${product.price.toLocaleString()}`}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <Footer />
            </div>
        </>
    );
};

export default Shop13;
